export default {
    pageTitle: 'TAROT',
    subscriptioRoute: '/assinar?ref={hash}',
    orbiaTrigger: {
        trigger: 'Tem dúvidas sobre sua tiragem? Pergunte ao Orbia e aprofunde sua leitura!',
        hiddenTemplate: `
            Cartas Tiradas do Tarot:
            {cards}

            Com base nessas cartas: 
        `
    },

    home: {
        decision: 'Decisão',
        situation: 'Situação',
        title: 'Consulta ao Tarot',
        how: 'Como consultar o Tarot?',
        canHelp: 'Como podemos te ajudar?',
        howTarotWorks: 'Como o Tarot funciona?',

        testimonials: {
            title: 'O que dizem as pessoas que tiveram suas vidas transformadas pelo Tarot?',
            subtitle:
                'Veja a opinião de pessoas que diariamente exploram tudo o que o Tarot tem para oferecer e ganham informações valiosas para suas jornadas:',
            description:
                'Acesse orientações ilimitadas sobre amor, trabalho, autoconhecimento e muito mais, sempre que precisar. Desbloqueie a sabedoria das cartas e direcione o seu futuro.',

            list: `[
                {
                    "testimonial": "A <b>revelação do tarô</b> veio exatamente na área que perguntei! Incrível! Me ajudou a tomar uma <b>decisão importante</b> no <b>trabalho</b> e estou colhendo os frutos disso! Gratidão!!!",
                    "name": "Marcelo",
                    "sign": "Taurino",
                    "icon": "neo-tarot/testimonials-icon-touro.svg",
                    "image": "neo-tarot/testimonial-image-marcelo.png"
                },
                {
                    "testimonial": "Estava há tempos para fazer a consulta com o Tarot mas não criava coragem para ir em frente. Resolvi que seria hoje e que estava propícia a <b>receber a mensagem</b> que fosse. Fiquei muita surpresa e grata pelas <b>revelações sobre meu relacionamento!</b>",
                    "name": "Sandra",
                    "sign": "Capricorniana",
                    "icon": "neo-tarot/testimonials-icon-capricornio.svg",
                    "image": "neo-tarot/testimonial-image-sandra.png"
                },
                {
                    "testimonial": "O tarot me <b>tranquiliza</b> e me guia nos caminhos da vida. Ao me entender e entender os outros, consigo lidar com o <b>amor</b> de uma forma mais <b>leve e saudável.</b>",
                    "name": "Marina",
                    "sign": "Geminiana",
                    "icon": "neo-tarot/testimonials-icon-gemeos.svg",
                    "image": "neo-tarot/testimonial-image-marina.png"
                },
                {
                    "testimonial": "Tiro uma carta <b>todos os dias</b> e sempre me surpreendo com os <b>conselhos certeiros</b> que o tarot me dá, estou aprendendo muito sobre minha <b>espiritualidade.</b>",
                    "name": "Samuel",
                    "sign": "Aquariano",
                    "icon": "neo-tarot/testimonials-icon-aquario.svg",
                    "image": "neo-tarot/testimonial-image-samuel.png"
                }
            ]`
        },

        games: {
            flagNew: 'NOVO!',

            loveTarot: {
                title: 'Tarot do Amor',
                description:
                    'Tiragens e interpretações específicas para as perguntas mais comuns nos assuntos do coração.',

                advice: {
                    title: 'Conselho do dia',
                    description: 'Para qualquer pergunta simples sobre a vida amorosa'
                },

                mirrorOfHearth: {
                    title: 'Espelho do Coração',
                    description: 'Perguntas sobre relações do passado, do presente, do futuro e desafios'
                },

                templeOfLove: {
                    title: 'Templo do Amor',
                    description:
                        'Um retrato completo de qualquer relação: aspectos mentais e emocionais de ambas as partes'
                }
            },

            default: {
                title: 'Tarot Tradicional',
                description: 'Diversas tiragens para dúvidas, conselhos e meditação com a interpretação clássica.',

                situation: {
                    title: 'Situação',
                    description: 'Compreender a raiz e o andamento de um problema'
                },

                decision: {
                    title: 'Decisão',
                    description: 'Avaliar duas opções para fazer uma escolha'
                },

                classic: {
                    title: 'Tarot clássico',
                    description: 'Orientação, conselhos e meditação'
                }
            },

            orbia: {
                ribbonText: 'INTERATIVO',
                title: 'Tarot Inteligente',
                description: 'Conselhos e tiragens que trazem respostas personalizadas unindo tecnologia e intuição.',

                advice: {
                    title: 'Conselho do Dia',
                    description:
                        'Conselhos fáceis de entender para começar o dia, tomar decisões importantes ou enxergar com mais clareza os caminhos à sua frente.'
                },

                doubts: {
                    title: 'Tira-dúvidas',
                    description:
                        'Faça uma pergunta e receba interpretações únicas em um jogo interativo com duas cartas.'
                }
            }
        },

        description: {
            link: 'Ler mais',
            introduction:
                'Olá, {name}. Lembre-se de que o Tarot é uma ferramenta de autoconhecimento que deve ser usada com responsabilidade, quando  você precisar se conectar mais profundamente com as forças que regem o universo. ',
            full: `<span>Fazer uma consulta trará <strong>revelações</strong> que poderão influenciar a <strong>linha do tempo de sua vida</strong>, portanto, reflita sobre o que lhe foi transmitido de forma <strong>intuitiva</strong> mas ao mesmo
                    tempo <strong>consciente</strong>.</span>
                    <span>A carta escolhida é a que possui mais afinidade com o seu momento ou pergunta e traz a orientação mais apropriada.
                    Mesmo que você não receba a resposta que gostaria, não é recomendado repetir a consulta no mesmo instante.
                    Releia o conteúdo da carta e reflita sobre a mensagem que lhe foi transmitida, pois é a que traz o melhor conselho para você agora.</span><hr>
                    <span>Saiba que o Tarot é um espelho da nossa alma e reflete todo o espectro da experiência humana
                    através de <strong>arquétipos</strong>. É uma das conexões mais antigas entre os seres humanos e as
                    divindades, tendo o papel de nos aproximar de algo superior.</span>
                    <span>Seu estudo representa uma viagem de descoberta interior, onde passamos a conhecer melhor a nós
                    mesmos e o atual momento o qual estamos inseridos.</span>
                    <span>É um oráculo que caminha lado a lado com a <strong>astrologia</strong> e a <strong>alquimia</strong>, onde em suas cartas há uma correspondência
                    alquímica, um signo astrológico e um número para cada arquétipo. As cartas podem ser consideradas uma jornada
                    que nos ajuda a obter uma melhor compreensão do passado, presente e futuro.</span>`
        },

        howConsult: `<ul>
                        <li>Antes de iniciar sua consulta, verifique se você está em um ambiente tranquilo e que não seja interrompido. Tente não desviar sua atenção a outros estímulos e prepare-se para se concentrar apenas ao momento atual.</li>
                        <li>Clique em "<strong>Iniciar Consulta</strong>" e concentre-se para em seguida <strong>mentalizar uma questão</strong> importante da sua vida por alguns instantes. Pode ser uma pergunta específica, uma dica de como se portar em uma situação ou apenas uma revelação para o seu dia.</li>
                        <li>Direcione <strong>toda a sua intenção</strong> a esta mentalização, solicitando uma resposta apropriada. Faça isso com calma e pelo tempo que achar adequado.</li>
                        <li>Em seguida, prossiga com a sua consulta clicando em <strong>retirar carta</strong> para revelar uma carta ressonante com a sua mentalização. A mensagem contida nesta carta é para você - <strong>e você apenas</strong>. É a mais indicada para o seu momento atual ou a situação mentalizada. Uma nova consulta, principalmente sobre o mesmo assunto, não deve ser repetida até que tenha havido reflexão e entendimento do que lhe foi transmitido.</li>
                     </ul>`,

        gameSimple: {
            title: 'Consulta Simples',
            description: 'Orientação, conselhos e meditação'
        },

        gameSituation: {
            title: 'Situação',
            description: 'Compreender a raiz e o andamento de um problema'
        },

        gameDecision: {
            title: 'Decisão',
            description: 'Avaliar duas opções para fazer uma escolha'
        },

        frustration: {
            unlock: 'Desbloquear',
            experiment: 'Experimente'
        },

        appPromotion: {
            title: 'Você ganhou uma tiragem de tarot grátis no app!',
            description:
                'Escolha entre tarot tradicional ou do amor. <b>Disponível somente para quem acessa pelo aplicativo.</b>',
            downloadButton: 'Baixar app no <b>Google Play</b>',
            downloadButtonIOS: 'Baixar app na <b>App Store</b>'
        }
    },

    history: {
        filter: {
            all: 'Todos',
            loveTarot: 'Amor',
            default: 'Tradicional',
            orbia: 'Tarot Inteligente',
            title: 'Filtrar por: <strong>{filterType}</strong>'
        },

        noContent: {
            subscriber: {
                button: 'Eu quero!',
                paragraph: 'Você ainda não possui revelações, faça um jogo para começar'
            },

            noSubscriber: {
                button: 'Desbloquear tarot ilimitado',
                paragraph: 'Faça jogos completos sempre que precisar, salve suas interpretações e sentimentos!'
            }
        },

        emotions: {
            sad: 'Eu me senti <b>Mal</b> à respeito dessa revelação.',
            happy: 'Eu me senti <b>Bem</b> à respeito dessa revelação.',
            neutral: 'Eu me senti <b>Normal</b> à respeito dessa revelação.',
            verySad: 'Eu me senti <b>Péssimo</b> à respeito dessa revelação.',
            fabulous: 'Eu me senti <b>Incrível</b> à respeito dessa revelação.'
        },

        exclusion: {
            no: 'Cancelar',
            yes: 'Excluir',
            message: 'Tem certeza que deseja excluir esta revelação?'
        },

        menu: {
            history: 'Histórico',
            revelation: 'Minhas Revelações'
        },

        wantStudy: {
            arcaneRoute: '/tarot',
            button: 'Lista de Arcanos',
            title: 'Quer estudar o Tarot?',
            paragraph: 'Veja todas as Interpretações'
        },

        lastRevelated: {
            title: 'Última revelação',
            saveConsult: 'Salvar Consulta',
            gameType: '{area} - <strong>{game}</strong>'
        }
    },

    shuffleCards: {
        ready: 'Estou pronto',
        changeGame: 'Alterar tipo de consulta',

        messages: {
            direct: 'direcionando <strong>toda a sua intenção</strong> ao momento.',
            breath: 'Respire fundo e <strong>concentre-se</strong> por alguns instantes…',
            mental: '<strong>Mentalize a sua questão</strong> e continue quando estiver pront{prefix}',
            mentalReference: {
                he: 'o',
                she: 'a'
            }
        }
    },

    cardsSelector: {
        buttonReady: 'Ver resultado',

        default: {
            situation: {
                0: 'Escolha a primeira carta, que representará o <strong>Passado</strong> da sua situação',
                1: 'Escolha a segunda carta, que representará o <strong>Presente</strong> da sua situação',
                2: 'Escolha a terceira carta, que representará o <strong>Futuro provável</strong> da sua situação'
            },

            decision: {
                1: 'Escolha a segunda carta, que representará <strong>sua outra opção</strong>',
                0: 'Escolha a primeira carta, que representará <strong>uma das suas opções</strong>',
                2: 'Escolha a terceira carta, que conterá <strong>um conselho</strong> para a sua decisão'
            },

            classic: {
                0: 'Escolha uma <strong> Carta do Tarot </strong>para ver uma resposta ressonante com a sua <strong>mentalização</strong>.'
            }
        },

        loveTarot: {
            advice: { 0: 'Escolha <strong>uma carta</strong> para receber seu conselho' },

            mirrorOfHearth: {
                0: 'Escolha <strong>a primeira carta</strong>, que representará a <strong>origem da situação</strong>',
                1: 'Escolha <strong>a segunda carta</strong>, que representará o <strong>contexto atual</strong> da situação',
                2: 'Escolha <strong>a terceira carta</strong>, que representará <strong>a direção</strong> para onde a situação está caminhando'
            },

            templeOfLove: {
                0: 'Escolha a <strong>primeira carta</strong>, que representará <strong>as suas intenções</strong>',
                1: 'Escolha a <strong>segunda carta</strong>, que representará <strong>as  intenções da outra pessoa</strong>',
                2: 'Escolha a <strong>terceira carta</strong>, que representará <strong>os seus sentimentos</strong>',
                3: 'Escolha a <strong>quarta carta</strong>, que representará <strong>os sentimentos da outra pessoa</strong>',
                4: 'Escolha a <strong>quinta carta</strong>, que representará <strong>a síntese da relação</strong>'
            }
        },

        orbia: {
            advice: {
                0: 'Escolha <strong>uma carta</strong> para receber seu conselho'
            },

            doubts: {
                0: 'Escolha a <strong>primeira</strong> carta',
                1: 'Escolha a <strong>segunda</strong> carta'
            }
        }
    },

    gameResume: {
        back: 'Voltar',
        yourCard: 'Sua carta',
        readAbout: 'Ler sobre',
        saveConsult: 'Salvar consulta',
        interpretation: 'Interpretação',
        interact: 'Toque nas cartas para ler a interpretação',

        feedback: {
            button: 'Enviar Opinião!',
            thanks: 'Obrigado por nos enviar sua opinião!',
            paragraph: 'Sua opinião é opcional, mas muito importante! O que achou desse conteúdo?'
        },

        classical: {
            yourCard: 'Sua Carta',

            situation: {
                0: {
                    title: 'Passado',
                    description: 'Como se originou a situação, raiz de um problema.'
                },

                1: {
                    title: 'Presente',
                    description: 'A situação atual, de um ponto de vista neutro.'
                },

                2: {
                    title: 'Futuro',
                    description:
                        'Acontecimento provável, se nenhuma mudança ou atitude ocorrer. Lembre-se: <strong>quem faz seu destino é você</strong>.'
                }
            },

            decision: {
                0: {
                    title: 'Opção 1',
                    description: 'Possível resultado de fazer esta escolha.'
                },

                1: {
                    title: 'Opção 2',
                    description: 'Possível resultado de fazer esta escolha.'
                },

                2: {
                    title: 'Conselho',
                    description:
                        'Uma orientação  sobre como chegar à  uma conclusão. Lembre-se: <strong>quem faz seu destino é você</strong>.'
                }
            }
        },

        love: {
            advice: {
                title: 'Conselho',
                description: 'Símbolos que irão te ajudar a refletir e tomar decisões sobre a sua situação atual'
            },

            mirror: {
                0: {
                    title: 'Origem',
                    description: 'Raiz e/ou motivação da situação'
                },

                1: {
                    title: 'Contexto',
                    description: 'O que está acontecendo no presente, que pode ou não estar claro para você'
                },

                2: {
                    title: 'Direção',
                    description: 'Tendências futuras, que podem ser modificadas pela sua atitude'
                }
            },

            temple: {
                you: 'Você',
                another: 'A outra pessoa',

                0: {
                    title: 'Intenção',
                    description: 'O que ambos desejam da relação, conscientemente ou não'
                },

                1: {
                    title: 'Sentimento',
                    description: 'O que sentem um pelo outro'
                },

                2: {
                    title: 'Síntese',
                    description: 'Energia do par e tendência para o futuro próximo'
                }
            }
        }
    },

    interpretation: {
        readMore: 'Ler Mais',
        result: 'Resultado da sua consulta',
        simbolism: 'O simbolismo por trás da carta {card}'
    },

    feedback: {
        description: 'Descrição',
        saveTitle: 'Salvar consulta',
        editTitle: 'Editar consulta',
        selectPerceptions: 'Selecione algumas percepções',
        howYouFeel: 'Como se sentiu a respeito dessa revelação?',
        descriptionPlaceholder: 'Ex.: A revelação que obtive me fez refletir à respeito de uma situação que...',
        radioLike: 'Gostei, aprovado!',
        radioDidNotLike: 'Não gostei!',

        perceptions: {
            mental: 'Mental',
            bodily: 'Físico',
            emotional: 'Emocional',
            spiritual: 'Espiritual'
        }
    },

    errorView: {
        back: 'Voltar',
        button: 'Tentar novamente',
        message: 'Algo inesperado aconteceu, por favor tente novamente ou volte mais tarde'
    },

    gamePreview: {
        button: 'Começar',
        link: 'Alterar tipo de consulta',
        title: '<strong>{userName}</strong>, vamos começar a sua consulta.',

        paragraph: {
            simple: `Esta consulta trará <strong>revelações</strong> que poderão influenciar a linha do tempo de sua vida.
                     A carta escolhida é a que possui mais afinidade com o seu momento ou pergunta e traz a <strong>orientação</strong> mais apropriada, 
                     portanto, reflita sobre a resposta de forma intuitiva.`,

            decision: `Você escolherá três cartas que representarão <strong>as duas escolhas</strong> à
                        sua disposição e <strong>um conselho</strong> para auxiliar na sua decisão.<br />Mostraremos símbolos 
                        que despertarão a resposta no seu subconsciente. É comum que o Tarot exponha coisas 
                        que já sabemos mas, por diversos motivos, não enxergamos com clareza.  
                        Vamos começar essa viagem?`,

            situation: `Você escolherá três cartas que representarão o 
                        <strong>Passado</strong>, o <strong>Presente</strong> e o <strong>Futuro provável</strong> da sua situação.<br /> 
                        Mostraremos símbolos que despertarão a resposta no seu subconsciente. 
                        É comum que o Tarot exponha coisas que já sabemos mas, por diversos motivos, 
                        não enxergamos com clareza.  Vamos começar essa viagem?`
        },

        loveTarot: {
            description:
                'Mostraremos símbolos que despertarão a resposta no seu subconsciente. É comum que o Tarot exponha coisas que já sabemos mas, por diversos motivos, não enxergamos com clareza.',
            advice: '<strong>{userName}</strong>, vamos começar a sua consulta. Você escolherá <strong>uma carta</strong> que trará um <strong>conselho</strong> sobre a sua vida amorosa, para que você reflita ao longo do dia.',
            mirrorOfHearth:
                '<strong>{userName}</strong>, vamos começar a sua consulta. Você escolherá <strong>três cartas</strong>, cuja <strong>combinação dos significados</strong> trará a resposta para a pergunta sobre o relacionamento em questão.',
            templeOfLove:
                '<strong>{userName}</strong>, vamos começar a sua consulta. Você escolherá <strong>cinco cartas</strong> que representarão as <strong>intenções e sentimentos</strong> de ambas as partes, além de uma <strong>síntese da relação</strong>.'
        }
    },

    singleCard: {
        tarot: 'Tarot',
        back: '< Voltar',
        seeMore: 'saiba mais',
        saveConsult: 'Salvar consulta',
        switchGame: 'Alterar tipo de consulta',
        readInterpretation: 'Ler interpretação',
        fullDate: '<strong>{weekDay}</strong> | {day} de {month} de {year}',
        paragraph:
            'Olá, {name}. Esta consulta trará conselhos que poderão influenciar a linha do tempo de sua vida. O Tarot tem o papel de nos aproximar de algo superior, onde a carta escolhida é a que possui mais afinidade com o seu momento ou pergunta, trazendo uma orientação apropriada. Reflita sobre a resposta de forma intuitiva.',

        initConsult: {
            button: 'INICIAR CONSULTA',
            paragraph:
                'Tire uma <strong>Carta do Tarot</strong> para ver uma resposta ressoante com a sua <strong>mentalização</strong>.'
        },

        imersion: {
            breath: {
                1: 'Respire fundo e',
                2: '<strong>concentre-se</strong>',
                3: 'por alguns instantes'
            },

            direct: {
                1: 'direcionando',
                2: '<strong>toda a sua intenção</strong>',
                3: 'ao momento.'
            }
        },

        mental: {
            button: 'RETIRAR CARTA',
            title: 'MENTALIZE UMA QUESTÃO',
            paragraph: 'Quando estiver pronto, veja a carta ressoante com a sua mentalização'
        },

        countdown: {
            seeAgain: 'Ver novamente',
            await: 'Aguarde para fazer uma nova consulta.'
        }
    },

    aiInterpreter: {
        cta: 'Pergunte Agora!',
        title: 'Combinação dos Arcanos'
    },

    orbia: {
        navigationTitle: 'TAROT INTELIGENTE',

        howDidWork: {
            buttonLabel: 'Reportar um erro',
            title: 'COMO O TAROT DO ORBIA FUNCIONA',
            description: `
            <p>A tiragem de Tarot pelo Orbia funciona como no Tarot tradicional: as cartas são escolhidas e interpretadas a partir de uma pergunta ou intenção. A diferença é que aqui a tecnologia entra como aliada — com a ajuda da inteligência artificial, a interpretação ganha mais precisão, profundidade e direcionamento, respeitando a simbologia e os arquétipos clássicos do Tarot.</p>
            <p>Assim como no método tradicional, cada tiragem é um espelho da alma, refletindo emoções, desafios e potenciais por meio dos arquétipos presentes nas cartas. A IA, nesse processo, atua como uma facilitadora, traduzindo essas mensagens de forma clara e personalizada, tornando a experiência acessível e intuitiva. </p>
            <p>Quando o Tarot digital é utilizado para perguntas simples, reflexão e autoconhecimento, a experiência pode ser tão transformadora quanto uma consulta presencial. Mas, se precisar de ajuda com assuntos complexos e previsões, não deixe de consultar um tarólogo profissional!</p>
            `
        },

        home: {
            testingPhaseWarning: 'O Tarot do Orbia está em fase de testes para assinantes selecionados.'
        },

        ask: {
            whatDoYouWantToKnow: 'O que você quer saber?',
            beObjective: 'Seja objetiv{genderSuffix} e faça apenas uma pergunta por consulta:',

            advice: {
                button: 'Começar',
                title: 'Conselho do Dia',
                description: `
                    <p>Você escolherá uma carta que poderá usar como conselho para começar o dia, tomar decisões importantes ou enxergar com mais clareza os caminhos à sua frente.</p>
                    <p>O Orbia utilizará o Tarot para elaborar esses conselhos, mas não deixe de usar sua própria intuição para tirar o melhor desse momento!</p>
                `
            },

            doubts: {
                title: 'Tira-dúvidas',
                description:
                    '<strong>{userName}</strong>, duas cartas combinadas darão uma resposta à sua questão. O Orbia irá relacionar as cartas ao contexto da sua questão, mas <strong>não deixe de usar sua própria intuição</strong> para tirar o melhor desse momento!'
            }
        }
    }
};
